
import React, { useContext, useEffect } from 'react';
import {
  Typography,
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import { useState } from 'react';
import FormComponent from '../components/FormComponent/FormComponent';
import BtnComponent from '../components/buttonComponent/BtnComponent';
import SecondaryBtnComponent from '../components/buttonComponent/SecondaryBtnComponent';
import StepperCustom from '../components/StepperComponent/StepperCustom';
import { Grid, Hidden, Paper } from '@mui/material';
import { ThemeProvider } from '@mui/styles';
import { createTheme } from '@mui/system';
import CarouselWrapper from '../components/CarouselComponent/CarouselWrapper';
import { Link, useNavigate } from 'react-router-dom';
import GlobalContext from '../context/globalContext';
import { useMutation } from '@apollo/client';
import {
  CREATE_ACCOUNT,
  IS_USER_VERIFIED,
  VERIFY_USER_IN_KEYCLOAK,
} from '../services/userQueries/userService';
import { useSnackbar } from 'notistack';
import { SimpleBackdrop } from '../components/SimpleBackdropComponent/SimpleBackdrop';
import {
  getFormattedInputBasedOnFieldName,
  getSSNFormatNo,
  getUSFormatPhoneNo,
  isObjectEmpty,
  validateSSNNo,
  isPropertyPresentInArrayOfObjects,
  getEquivalentObjectFromContext,
  validatePassword,
  getZipFormatNo,
} from '../shared/helper';
import TermsAndCondition from '../components/termsAndCondition/TermsAndCondition';
import FormControl from '@mui/material/FormControl';
import { ERROR_MSGS, SIGNUP } from '../shared/Strings';

const radio = {
  '&:hover': {
    bgcolor: 'transparent',
  },
};

function Signup() {
  const { carousel, user_registration_fields } = useContext(GlobalContext);
  const theme = createTheme();
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const [next, setNext] = useState(false);
  const [checked, setChecked] = useState(false);
  const [accountCreationFields, setAccountCreationFields] = useState({});
  const [radioValue, setRadioValue] = useState('memberId');
  const [isMemberIdHidden, setIsMemberIdHidden] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const steps = ['Member Details', 'Create Account'];

  const [verifyUser, verifyUserCall] = useMutation(IS_USER_VERIFIED, {
    fetchPolicy: 'no-cache',
    onError: err => {
      enqueueSnackbar(ERROR_MSGS.REACH_CUSTOMER_CARE, {
        variant: 'error',
      });
    },
  });

  const [createNewAccount, createNewAccountCall] = useMutation(CREATE_ACCOUNT, {
    onError: err => {
      enqueueSnackbar(ERROR_MSGS.WENT_WRONG_CREATE_ACCOUNT, {
        variant: 'error',
      });
    },
  });

  const [checkExistingUser, checkExistingUserCall] = useMutation(
    VERIFY_USER_IN_KEYCLOAK,
    {
      fetchPolicy: 'no-cache',
    }
  );

  const handleNext = () => {
    setActiveStep(1);
  };
  const handleBack = () => {
    setActiveStep(0);
  };

  const memberValues = {
    groupnumber: '',
    firstname: '',
    lastname: '',
    ssn: '',
    date: '',
    zipcode: '',
  };

  const createAccountValues = {
    email: '',
    phonenumber: '',
    password: '',
    confirmpassword: '',
  };

  const [memberFormValues, setMemberFormValues] = useState(memberValues);
  const [memberFormErrors, setMemberFormErrors] = useState({});

  const [accountFormValues, setAccountFormValues] =
    useState(createAccountValues);
  const [accountFormErrors, setAccountFormErrors] = useState({});

  const setMemberValuesForUserValidation = () => {
    const result = {};
    const arr = getInputFieldArrayForUserIdentification(inputFieldArray);
    for (let value in memberValues) {
      if (isPropertyPresentInArrayOfObjects(value, arr)) {
        result[value] = '';
      }
    }
    setMemberFormValues(result);
  };

  useEffect(() => {
    setMemberValuesForUserValidation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (
      Object.keys(memberFormErrors).length === 0 &&
      next &&
      verifyUserCall?.data?.verifyUserInSmileCdr
    ) {
      enqueueSnackbar(ERROR_MSGS.ACCOUNT_VERIFY_SUCCESS, {
        variant: 'success',
      });
      handleNext();
    }
  }, [enqueueSnackbar, memberFormErrors, next, verifyUserCall?.data]);

  React.useEffect(() => {
    if (
      Object.keys(accountFormErrors).length === 0 &&
      createNewAccountCall?.data?.createAccountMember
    ) {
      enqueueSnackbar(ERROR_MSGS.ACCOUNT_CREATE_SUCCESS, {
        variant: 'success',
      });
      navigate('/otpverification', {
        state: {
          phoneNumber: accountCreationFields.phonenumber,
          userId: createNewAccountCall.data.createAccountMember.userId,
        },
      });
    }
  }, [
    enqueueSnackbar,
    navigate,
    accountFormErrors,
    accountCreationFields,
    createNewAccountCall?.data,
  ]);

  const handleChange = e => {
    const { name, value } = e.target;
    if (name === 'ssn') {
      setMemberFormValues({
        ...memberFormValues,
        [name]: getSSNFormatNo(value),
      });
    } else if (name === 'zipcode') {
      setMemberFormValues({
        ...memberFormValues,
        [name]: getZipFormatNo(value),
      });
    } else {
      setMemberFormValues({ ...memberFormValues, [name]: value });
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    const targetElements = e.target.elements;
    const userIdFields = {};
    for (let i = 0; i < user_registration_fields.length; i++) {
      const fieldName = user_registration_fields[i].name;
      userIdFields[fieldName] = getFormattedInputBasedOnFieldName(
        fieldName,
        targetElements[fieldName]?.value
      );
    }
    setAccountCreationFields(userIdFields);
    setMemberFormErrors(memberValidate(memberFormValues));
    if (isObjectEmpty(memberValidate(memberFormValues))) {
      verifyUser({
        variables: {
          verifyUserInSmileRequest: {
            memberId: userIdFields.groupnumber,
            ssnOrTin: userIdFields.ssn,
            firstName: userIdFields.firstname,
            lastName: userIdFields.lastname,
            birthDate: userIdFields.date,
            postalCode: userIdFields.zipcode,
          },
        },
      });
    }
    setNext(true);
  };

  const accountHandleChange = e => {
    const { name, value } = e.target;
    if (name === 'phonenumber') {
      setAccountFormValues({
        ...accountFormValues,
        [name]: getUSFormatPhoneNo(value),
      });
    } else {
      setAccountFormValues({ ...accountFormValues, [name]: value });
    }
  };

  const accountHandleSubmit = e => {
    e.preventDefault();
    const targetElements = e.target.elements;
    const userIdFields = {};
    for (let i = 0; i < createAccountArray.length; i++) {
      const fieldName = createAccountArray[i].name;
      userIdFields[fieldName] = getFormattedInputBasedOnFieldName(
        fieldName,
        targetElements[fieldName].value
      );
    }
    const allFields = { ...accountCreationFields, ...userIdFields };
    setAccountCreationFields(allFields);
    setAccountFormErrors(accountValidate(accountFormValues));
    if (isObjectEmpty(accountValidate(accountFormValues))) {
      checkExistingUser({
        variables: {
          verifyUserRequest: {
            phoneNumber: '',
            emailId: allFields.email,
          },
        },
      })
        .then(result => {
          enqueueSnackbar(ERROR_MSGS.USER_EMAIL_ALREADY_EXIST, {
            variant: 'error',
          });
        })
        .catch(err => {
          checkExistingUser({
            variables: {
              verifyUserRequest: {
                phoneNumber: allFields.phonenumber,
                emailId: '',
              },
            },
          })
            .then(result => {
              enqueueSnackbar(ERROR_MSGS.USER_PHONE_ALREADY_EXIST, {
                variant: 'error',
              });
            })
            .catch(err => {
              createNewAccount({
                variables: {
                  registerUserRequest: {
                    memberId: allFields.groupnumber,
                    ssnOrTin: allFields.ssn,
                    firstName: allFields.firstname,
                    lastName: allFields.lastname,
                    emailId: allFields.email,
                    phoneNumber: allFields.phonenumber,
                    birthDate: allFields.date,
                    password: allFields.password,
                    postalCode: allFields.zipcode,
                  },
                },
              });
            });
        });
    }
  };

  const memberValidate = values => {
    const errors = {};
    const firstNameRegex = /^[a-z .']+$/i;
    const lastNameRegex = /^[a-z .']+$/i;
    const zipcodeRegex = /^\d{5}(-\d{4})?$/;

    if (!isMemberIdHidden) {
      // Not doing error check if memberId field is hidden
      if (
        isPropertyPresentInArrayOfObjects(
          'groupnumber',
          user_registration_fields
        )
      ) {
        if (!values.groupnumber) {
          errors.groupnumber = ERROR_MSGS.REQUIRED_FIELD.MEMBER_ID;
        } else if (values.groupnumber.length !== 9) {
          errors.groupnumber = ERROR_MSGS.MEMBER_ID_VALID;
        }
      }
    }

    if (
      isPropertyPresentInArrayOfObjects(
        SIGNUP.FIRST_NAME,
        user_registration_fields
      )
    ) {
      if (!values.firstname) {
        errors.firstname = ERROR_MSGS.REQUIRED_FIELD.FIRST_NAME;
      } else if (!firstNameRegex.test(values.firstname)) {
        errors.firstname = ERROR_MSGS.FIRST_NAME_INVALID;
      }
    }

    if (
      isPropertyPresentInArrayOfObjects(
        SIGNUP.LAST_NAME,
        user_registration_fields
      )
    ) {
      if (!values.lastname) {
        errors.lastname = ERROR_MSGS.REQUIRED_FIELD.LAST_NAME;
      } else if (!lastNameRegex.test(values.lastname)) {
        errors.lastname = ERROR_MSGS.LAST_NAME_INVALID;
      }
    }

    if (
      isPropertyPresentInArrayOfObjects(SIGNUP.DATE, user_registration_fields)
    ) {
      if (!values.date) {
        errors.date = ERROR_MSGS.REQUIRED_FIELD.DATE_OF_BIRTH;
      }
    }

    if (isMemberIdHidden) {
      if (
        isPropertyPresentInArrayOfObjects(SIGNUP.SSN, user_registration_fields)
      ) {
        if (!values.ssn) {
          errors.ssn = ERROR_MSGS.REQUIRED_FIELD.SSN;
        } else if (validateSSNNo(values.ssn)) {
          errors.ssn = ERROR_MSGS.INVALID_SSN;
        }
      }
    }

    if (
      isPropertyPresentInArrayOfObjects(
        SIGNUP.ZIPCODE,
        user_registration_fields
      )
    ) {
      if (!values.zipcode) {
        errors.zipcode = ERROR_MSGS.REQUIRED_FIELD.ZIPCODE;
      } else if (!zipcodeRegex.test(values.zipcode)) {
        errors.zipcode = ERROR_MSGS.INVALID_ZIPCODE;
      }
    }

    return errors;
  };

  const accountValidate = values => {
    const errors = {};
    const mailregex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    const phoneNumberRegex = /^[2-9]\d{2}\d{3}\d{4}$/i;

    if (!values.email) {
      errors.email = ERROR_MSGS.REQUIRED_FIELD.EMAIL;
    } else if (!mailregex.test(values.email)) {
      errors.email = ERROR_MSGS.NOT_VALID_EMAIL;
    }

    if (!values.phonenumber) {
      errors.phonenumber = ERROR_MSGS.REQUIRED_FIELD.PHONE_NUMBER;
    } else if (values.phonenumber.length !== 14) {
      errors.phonenumber = ERROR_MSGS.PHONE_NUMBER_TEN_DIGIT;
    } else if (
      !phoneNumberRegex.test(
        getFormattedInputBasedOnFieldName(
          SIGNUP.PHONE_NUMBER,
          values.phonenumber
        )
      )
    ) {
      errors.phonenumber = ERROR_MSGS.INVALID_PHONE;
    }

    if (!values.password) {
      errors.password = ERROR_MSGS.REQUIRED_FIELD.PASSWORD;
    } else if (values.password.length < 8) {
      errors.password = ERROR_MSGS.PASSWORD_LENGTH_8;
    } else if (validatePassword(values.password)) {
      errors.password = ERROR_MSGS.PASSWORD_MUST_INCLUDE;
    }

    if (!values.confirmpassword) {
      errors.confirmpassword = ERROR_MSGS.CONFIRM_PASSWORD;
    } else if (values.confirmpassword !== values.password) {
      errors.confirmpassword = ERROR_MSGS.PASSWORD_NOT_MATCH;
    }

    return errors;
  };

  const inputFieldArray = [
    {
      errorMessage: memberFormErrors.groupnumber,
      value: memberFormValues.groupnumber,
      onChange: handleChange,
      name: 'groupnumber',
      hide: isMemberIdHidden,
    },
    {
      onChange: handleChange,
      value: memberFormValues.ssn,
      errorMessage: memberFormErrors.ssn,
      name: 'ssn',
      hide: !isMemberIdHidden,
    },
    {
      value: memberFormValues.firstname,
      errorMessage: memberFormErrors.firstname,
      onChange: handleChange,
      name: 'firstname',
    },
    {
      value: memberFormValues.lastname,
      errorMessage: memberFormErrors.lastname,
      onChange: handleChange,
      name: 'lastname',
    },
    {
      value: memberFormValues.date,
      errorMessage: memberFormErrors.date,
      onChange: handleChange,
      name: 'date',
    },
    {
      value: memberFormValues.zipcode,
      errorMessage: memberFormErrors.zipcode,
      onChange: handleChange,
      name: 'zipcode',
    },
  ];
  const createAccountArray = [
    {
      title: SIGNUP.LABEL.email,
      placeholder: SIGNUP.PLACE_HOLDER.email,
      type: 'text',
      name: 'email',
      value: accountFormValues.email,
      onChange: accountHandleChange,
      errorMessage: accountFormErrors.email,
    },
    {
      title: SIGNUP.LABEL.phone,
      placeholder: SIGNUP.PLACE_HOLDER.phone,
      helperText: SIGNUP.OTP_CONFIRMATION_TEXT,
      type: 'text',
      onChange: accountHandleChange,
      name: 'phonenumber',
      value: accountFormValues.phonenumber,
      errorMessage: accountFormErrors.phonenumber,
      adornment: '+1',
      adornmentPosition: 'start',
    },
    {
      title: SIGNUP.LABEL.password,
      placeholder: SIGNUP.PLACE_HOLDER.password,
      type: 'password',
      onChange: accountHandleChange,
      name: 'password',
      value: accountFormValues.password,
      errorMessage: accountFormErrors.password,
    },
    {
      title: SIGNUP.LABEL.confirm_password,
      placeholder: SIGNUP.PLACE_HOLDER.confirm_password,
      type: 'password',
      onChange: accountHandleChange,
      name: 'confirmpassword',
      value: accountFormValues.confirmpassword,
      errorMessage: accountFormErrors.confirmpassword,
    },
  ];
  const subHeading = {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '24px',
    marginTop: '40px',
  };

  const getInputFieldArrayForUserIdentification = list => {
    return list
      .filter(item => {
        return isPropertyPresentInArrayOfObjects(
          item.name,
          user_registration_fields
        );
      })
      .map(item => {
        const correspondingObject = getEquivalentObjectFromContext(
          item.name,
          user_registration_fields
        );
        for (let prop in correspondingObject) {
          if (correspondingObject[prop] !== null) {
            item[prop] = correspondingObject[prop];
          }
        }
        return item;
      });
  };

  const handleRadioClick = event => {
    setRadioValue(event.target.value);
    if (event.target.value === 'memberId') {
      setIsMemberIdHidden(false);
    } else {
      setIsMemberIdHidden(true);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Grid container component="main" sx={{ height: '100vh' }}>
        <Hidden mdDown>
          <Grid item xs={false} sm={false} md={5}>
            <CarouselWrapper carouselConfig={carousel} />
          </Grid>
        </Hidden>
        <Grid
          item
          xs={12}
          md={7}
          component={Paper}
          square
          sx={{
            display: 'flex',
            justifyContent: 'center',
            background: '#f7f7f7',
          }}>
          <Box
            sx={{
              position: 'absolute',
              right: 0,
              m: 1,
              display: 'flex',
              justifyContent: 'flex-end',
              flexDirection: 'row',
              alignItems: 'center',
            }}>
            <Typography marginRight={1}>{SIGNUP.HAVE_ACCOUNT_TEXT}</Typography>
            <BtnComponent
              component={Link}
              to={'/login'}
              size="small"
              title={SIGNUP.BTN_TEXT_LOGIN}></BtnComponent>
          </Box>
          <Box
            sx={{
              my: 7,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'left',
              overflow: 'hidden',
              minWidth: { xs: '80vw', sm: '60vw', md: '35vw' },
            }}>
            <Typography variant="title">
              {SIGNUP.NEW_USER_REGISTER_TEXT}
            </Typography>
            <StepperCustom
              sx={{ mt: 5, alignItems: 'left' }}
              activeStep={activeStep}
              steps={steps}
            />

            {activeStep === 0 ? (
              <Box>
                <Typography sx={subHeading} variant="h6">
                  {SIGNUP.MEMBER_DETAILS_TEXT}
                </Typography>
                <FormControl>
                  <RadioGroup
                    sx={{ mt: 3 }}
                    row
                    aria-labelledby="row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    value={radioValue}
                    onChange={handleRadioClick}>
                    <FormControlLabel
                      sx={{ mr: 3 }}
                      value="memberId"
                      control={<Radio sx={radio} disableRipple />}
                      label={SIGNUP.RADIO_BUTTON_LABEL.member}
                    />
                    <FormControlLabel
                      value="ssn"
                      control={<Radio sx={radio} disableRipple />}
                      label={SIGNUP.RADIO_BUTTON_LABEL.security}
                    />
                  </RadioGroup>
                </FormControl>

                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 4 }}>
                  <FormComponent
                  minDate={true}
                    inputFieldArray={getInputFieldArrayForUserIdentification(
                      inputFieldArray
                    )}></FormComponent>

                  <BtnComponent
                    type="submit"
                    title={SIGNUP.BTN_TEXT_PROCEED}
                    width="144px"
                    //onClick={handleSubmit}
                    sx={{ mt: 4 }}></BtnComponent>
                </Box>
              </Box>
            ) : (
              <Box>
                <Typography sx={subHeading} variant="h6">
                  {/* name should be popup from props */}
                  {`Hey ${accountCreationFields.firstname}, let’s setup your account`}
                </Typography>
                <Box
                  component="form"
                  onSubmit={accountHandleSubmit}
                  sx={{ mt: 5 }}>
                  <FormComponent
                    inputFieldArray={createAccountArray}></FormComponent>

                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-start',

                      mt: 2,
                    }}>
                    <input
                      style={{ height: 15, width: 15, marginRight: '8px' }}
                      type="checkbox"
                      defaultChecked={checked}
                      onChange={() => setChecked(!checked)}
                    />
                    <Typography variant="body2">
                      {SIGNUP.PRIVACY_POLICY_TEXT}
                    </Typography>
                    <TermsAndCondition />
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'flex-start',
                      mt: 4,
                    }}>
                    <SecondaryBtnComponent
                      onClick={handleBack}
                      title={SIGNUP.BTN_TEXT_BACK}
                    />

                    <BtnComponent
                      sx={{ ml: 1 }}
                      type="submit"
                      title={SIGNUP.BTN_TEXT_CREATE_ACCOUNT}
                      fullWidth
                      disabled={!checked}
                    />
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
        </Grid>
        <SimpleBackdrop
          open={
            verifyUserCall.loading ||
            createNewAccountCall.loading ||
            checkExistingUserCall.loading
          }
        />
      </Grid>
    </ThemeProvider>
  );
}

export default Signup;
